export const AssetGroupsRoute = "/assetgroups";
export const NewAssetGroupsRoute = "/assetgroups/new";
export const AssetGroupRoute = "/assetgroups/:assetGroupId";
export const AssetClassesRoute = "/assetclasses";
export const NewAssetClassRoute = "/assetclasses/new";
export const AssetClassRoute = "/assetclasses/:assetClassId";
export const OutletUserExternalCredentialsRoute =
  "/outletuserexternalcredentials";
export const NewOutletUserExternalCredentialsRoute =
  "/outletuserexternalcredentials/new";
export const OutletUserExternalCredentialRoute =
  "/outletuserexternalcredentials/:outletUserExternalCredentialsId";
export const DriveFleetSourcesRoute = "/fleetsources";
export const NewDriveFleetSourceRoute = "/fleetsources/new";
export const AssetTraitsRoute = "/assettraits";
export const NewAssetTraitRoute = "/assettraits/new";
export const AssetTraitRoute = "/assettraits/:traitId";
